export const ADMIN_STATUS_OPTIONS = [
	{ value: 'all', label: 'All statuses' },
	{ value: 'active', label: 'Awaiting reply' },
	{ value: 'open', label: 'Open' },
	{ value: 'in_progress', label: 'In progress' },
	{ value: 'waiting_on_customer', label: 'Waiting on customer' },
	{ value: 'resolved', label: 'Resolved' },
	{ value: 'closed', label: 'Closed' },
];

export const CLIENT_STATUS_OPTIONS = [
	{ value: 'all', label: 'All tickets' },
	{ value: 'active', label: 'Active' },
	{ value: 'waiting_on_customer', label: 'Needs your reply' },
	{ value: 'resolved', label: 'Resolved' },
	{ value: 'closed', label: 'Closed' },
];

export const formatStatusLabel = (status, viewAs = 'admin') => {
	if (viewAs === 'customer') {
		switch (status) {
			case 'open':
			case 'in_progress':
				return 'Waiting for agent reply';
			case 'waiting_on_customer':
				return 'Waiting for your reply';
			case 'resolved':
				return 'Resolved';
			case 'closed':
				return 'Closed';
			default:
				return status.replace(/_/g, ' ');
		}
	}

	const option = ADMIN_STATUS_OPTIONS.find((o) => o.value === status);
	if (option) return option.label;
	return status.replace(/_/g, ' ');
};

export const statusColor = (status) => {
	switch (status) {
		case 'open':
			return 'blue';
		case 'in_progress':
			return 'orange';
		case 'waiting_on_customer':
			return 'purple';
		case 'resolved':
			return 'green';
		case 'closed':
			return 'gray';
		default:
			return 'gray';
	}
};

export const formatWhen = (date) =>
	date
		? new Date(date).toLocaleString(undefined, {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: '2-digit',
			})
		: '—';

export const filterClientTickets = (tickets, { statusFilter, search }) => {
	const term = search.trim().toLowerCase();
	return tickets.filter((ticket) => {
		if (statusFilter === 'active') {
			if (['closed', 'resolved'].includes(ticket.status)) return false;
		} else if (statusFilter !== 'all' && ticket.status !== statusFilter) {
			return false;
		}
		if (!term) return true;
		return (
			ticket.subject?.toLowerCase().includes(term) ||
			ticket.ticketNumber?.toLowerCase().includes(term) ||
			ticket.category?.toLowerCase().includes(term)
		);
	});
};

export const getClientTicketCounts = (tickets) => ({
	active: tickets.filter((t) => !['closed', 'resolved'].includes(t.status)).length,
	waiting: tickets.filter((t) => t.status === 'waiting_on_customer').length,
	done: tickets.filter((t) => ['closed', 'resolved'].includes(t.status)).length,
});

export const getAdminTicketCounts = (counts = {}) => ({
	active: (counts.open || 0) + (counts.in_progress || 0),
	waiting: counts.waiting_on_customer || 0,
	done: (counts.resolved || 0) + (counts.closed || 0),
});

export const getAdminPendingReplyCount = (counts = {}) =>
	(counts.open || 0) + (counts.in_progress || 0);
